import { TIME_OPTIONS } from '@monorepo/types';
import { DefaultOptions } from '@tanstack/react-query';

export enum QueryPriority {
  CRITICAL = 'CRITICAL',
  SECONDARY = 'SECONDARY',
  BACKGROUND = 'BACKGROUND',
}

export enum QueryConfigKeys {
  ORDERS = 'ORDERS',
  PURCHASE = 'PURCHASE',
  CART = 'CART',
  USERS = 'USERS',
  USER_CREDIT_HISTORY = 'USER_CREDIT_HISTORY',
  KYC = 'KYC',
  AFFILIATES = 'AFFILIATES',
  AUTH = 'AUTH',
  PAYOUTS = 'PAYOUTS',
  CURRENCIES = 'CURRENCIES',
  APP_CONFIG = 'APP_CONFIG',
  PAYMENT_PROVIDERS = 'PAYMENT_PROVIDERS',
  PRODUCTS = 'PRODUCTS',
  ADD_ONS = 'ADD_ONS',
  ACCOUNT = 'ACCOUNT',
  PROGRAMS = 'PROGRAMS',
  CONTEST_CATEGORY = 'CONTEST_CATEGORY',
  CONTEST_RANKINGS = 'CONTEST_RANKINGS',
  CHART_LAYOUTS = 'CHART_LAYOUTS',
  COMMUNITY_STATS = 'COMMUNITY_STATS',
  RELEASE = 'RELEASE',
}

type QueryConfigMap = Record<QueryConfigKeys, { staleTime: number }>;

export const QUERY_CONFIGS: QueryConfigMap = {
  [QueryConfigKeys.ORDERS]: {
    staleTime: TIME_OPTIONS.FIVE_MINUTES,
  },
  [QueryConfigKeys.PURCHASE]: {
    staleTime: TIME_OPTIONS.FIVE_MINUTES,
  },
  [QueryConfigKeys.CART]: {
    staleTime: TIME_OPTIONS.FIVE_MINUTES,
  },
  [QueryConfigKeys.USERS]: {
    staleTime: TIME_OPTIONS.INFINITY,
  },
  [QueryConfigKeys.USER_CREDIT_HISTORY]: {
    staleTime: 0, // Always consider stale for impersonation support
  },
  [QueryConfigKeys.KYC]: {
    staleTime: TIME_OPTIONS.ONE_HOUR,
  },
  [QueryConfigKeys.AFFILIATES]: {
    staleTime: TIME_OPTIONS.FIFTEEN_MINUTES,
  },
  [QueryConfigKeys.AUTH]: {
    staleTime: TIME_OPTIONS.INFINITY,
  },
  [QueryConfigKeys.PAYOUTS]: {
    staleTime: 0,
  },
  [QueryConfigKeys.CURRENCIES]: {
    staleTime: TIME_OPTIONS.ONE_HOUR,
  },
  [QueryConfigKeys.APP_CONFIG]: {
    staleTime: TIME_OPTIONS.FIVE_MINUTES,
  },
  [QueryConfigKeys.PAYMENT_PROVIDERS]: {
    staleTime: TIME_OPTIONS.ONE_HOUR,
  },
  [QueryConfigKeys.PRODUCTS]: {
    staleTime: TIME_OPTIONS.ONE_HOUR,
  },
  [QueryConfigKeys.ADD_ONS]: {
    staleTime: 0,
  },
  [QueryConfigKeys.ACCOUNT]: {
    staleTime: TIME_OPTIONS.FIVE_MINUTES,
  },
  [QueryConfigKeys.PROGRAMS]: {
    staleTime: TIME_OPTIONS.ONE_HOUR, // Programs don't change often
  },
  [QueryConfigKeys.CONTEST_CATEGORY]: {
    staleTime: TIME_OPTIONS.THIRTY_MINUTES,
  },
  [QueryConfigKeys.CONTEST_RANKINGS]: {
    staleTime: TIME_OPTIONS.ONE_MINUTE,
  },
  [QueryConfigKeys.CHART_LAYOUTS]: {
    staleTime: TIME_OPTIONS.ONE_MINUTE,
  },
  [QueryConfigKeys.COMMUNITY_STATS]: {
    staleTime: TIME_OPTIONS.ONE_MINUTE,
  },
  [QueryConfigKeys.RELEASE]: {
    staleTime: TIME_OPTIONS.ONE_DAY,
  },
};

export const queryConfig: DefaultOptions = {
  queries: {
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: TIME_OPTIONS.FIVE_MINUTES,
    refetchOnMount: true,
  },
};
